import React from 'react';
import { Cookie } from 'lucide-react';
import { COOKIE_POLICY_CONTENT } from '../../content/cookiePolicy';
import { LegalDocumentPage } from './LegalDocumentPage';

export function CookiePolicyPage() {
  const content = COOKIE_POLICY_CONTENT;

  return (
    <LegalDocumentPage
      canonicalPath="/cookie-policy"
      content={content}
      icon={Cookie}
      keywords="cookie policy, vevi monster cookies, essential cookies, analytics cookies, functional cookies"
      leadCompanyBlock={{
        title: content.controller.heading,
        intro: content.controller.intro,
        companyName: content.controller.companyName,
        companyDetails: content.controller.companyDetails,
        email: content.controller.email,
      }}
    />
  );
}
